import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom'; //withRouter needed on lect337? Not for me
import {connect} from 'react-redux';
import asyncComponent from './hoc/asyncComponent/asyncComponent';

import Layout from './hoc/Layout/Layout';
import './App.css';
import BurgerBuilder from './containers/BurgerBuilder/BurgerBuiilder';
import Logout from './containers/Auth/Logout/Logout';
import * as actions from './store/actions/index';

//below will dynamically add lazy loading to the app and routes
const asyncCheckout = asyncComponent(() => {
  return import('./containers/BurgerBuilder/Checkout/Checkout'); 
}); 

const asyncOrders = asyncComponent(() => {
  return import('./containers/Orders/Orders'); 
}); 


const asyncAuth = asyncComponent(() => {
  return import('./containers/Auth/Auth'); 
});    


class App extends Component {
componentDidMount() {
  this.props.onTryAutoSignup();
}

  render() {
    let routes = (
      <div>
        <Switch> 
        <Route path="/auth" component={asyncAuth} /> 
        <Route path="/" exact component={BurgerBuilder} />
        <Redirect to="/" />
        </Switch> 
      </div> 
    );

    if (this.props.isAuthenticated) {
      routes = (
        <div>
    {  <Switch> 
      <Route path="/checkout" component={asyncCheckout} /> 
      <Route path="/orders" component={asyncOrders} /> 
      <Route path="/logout" component={Logout} /> 
      <Route path="/auth" component={asyncAuth} /> 
      <Route path="/" exact component={BurgerBuilder} />
      <Redirect to="/" />
      </Switch> }
      </div> 
      );
    }

    return (
      <div >
    <Layout>
     {routes}
    </Layout>
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
      isAuthenticated: state.auth.token !== null
  };
};

const mapDispatchToProps = dispatch => {
  return {
      onTryAutoSignup: () => dispatch(actions.authCheckState())
   }; 
};  

export default connect(mapStateToProps, mapDispatchToProps)(App);
